"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var SegmentedControlWrapper = /** @class */ (function (_super) {
    __extends(SegmentedControlWrapper, _super);
    function SegmentedControlWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SegmentedControlWrapper.prototype.findSegments = function () {
        return this.findAll('.awsui-segment');
    };
    SegmentedControlWrapper.prototype.findSelectedSegment = function () {
        return this.find('.awsui-segment--selected');
    };
    return SegmentedControlWrapper;
}(dom_1.ComponentWrapper));
exports.default = SegmentedControlWrapper;
//# sourceMappingURL=awsui-segmented-control.js.map